/* eslint-disable max-len */
import React from 'react'
import CoverBlock from './CoverBlock'
import LogoBlock from './LogoBlock'
import PricingBlock from './PricingBlock'
import FeatureBlock from './FeatureBlocks/block'
import FeatureBlockIntro from './FeatureBlocks/introBlock'
import ContactModal from '../components/ContactModal'
import { engageFeatures, eventFeaures, adminFeatures } from './FeatureBlocks/featuresData'

const CommunitiesHome = () => {
   return (
      <>
         <div id="home" className="section">
            <CoverBlock />
            <LogoBlock />
         </div>
         {/* <div className="bg-black/20 py-32">
            <div className="communities-content-wrapper">
               <div className="grid grid-cols-2 gap-16" style={{ fontFamily2: 'futura' }}>
                  <div className="col-span-2">
                     <div className="text-center mb-16">
                        <div className="text-lg uppercase font-semibold tracking-tight text-white/80">
                           Features
                        </div>
                        <div
                           className="text-5xl font-medium tracking-tight text-white mt-4"
                           style={{ fontFamily: 'garamond' }}>
                           Everything you need
                        </div>
                     </div>
                     <div className="grid grid-cols-3 gap-8">
                        <div className="bg-white/5 rounded-3xl p-8 hover:bg-white/10 transition-all">
                           <div className="text-2xl font-medium text-white mb-4">
                              Community Forums
                           </div>
                           <div className="text-white/60">
                              Foster meaningful discussions with threaded conversations, rich media
                              support, and powerful moderation tools.
                           </div>
                        </div>
                        <div className="bg-white/5 rounded-3xl p-8 hover:bg-white/10 transition-all">
                           <div className="text-2xl font-medium text-white mb-4">Live Events</div>
                           <div className="text-white/60">
                              Host virtual meetups, webinars, and workshops with integrated video
                              streaming and interactive features.
                           </div>
                        </div>
                        <div className="bg-white/5 rounded-3xl p-8 hover:bg-white/10 transition-all">
                           <div className="text-2xl font-medium text-white mb-4">
                              Resource Library
                           </div>
                           <div className="text-white/60">
                              Share and organize documents, videos, and resources in a searchable
                              knowledge base.
                           </div>
                        </div>
                        <div className="bg-white/5 rounded-3xl p-8 hover:bg-white/10 transition-all">
                           <div className="text-2xl font-medium text-white mb-4">
                              Member Directory
                           </div>
                           <div className="text-white/60">
                              Connect members through detailed profiles, direct messaging, and
                              networking features.
                           </div>
                        </div>
                        <div className="bg-white/5 rounded-3xl p-8 hover:bg-white/10 transition-all">
                           <div className="text-2xl font-medium text-white mb-4">
                              Analytics Dashboard
                           </div>
                           <div className="text-white/60">
                              Track engagement, growth, and community health with comprehensive
                              analytics and reporting.
                           </div>
                        </div>
                        <div className="bg-white/5 rounded-3xl p-8 hover:bg-white/10 transition-all">
                           <div className="text-2xl font-medium text-white mb-4">
                              Custom Branding
                           </div>
                           <div className="text-white/60">
                              Make it yours with customizable themes, logos, and white-label
                              options.
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div> */}
         <div id="features" className="section">
            <FeatureBlockIntro />
            <FeatureBlock
               description="At its core, building a great community is about fostering meaningful connections and relationships. Communities lets your members create groups, start discussions, and share rich content with your community."
               mediaPlacement="left"
               label="Engage and Connect"
               title="Connect your Community"
               items={engageFeatures}
            />
            <FeatureBlock
               description="The Event features built into Communities are designed to help you with all aspects of your events. From handling registrations to payments to live event tools, Communities has you covered."
               mediaPlacement="right"
               label="Events and Payments"
               title="Your Event Hub"
               items={eventFeaures}
            />
            <FeatureBlock
               description="Every community is different. Communities lets you build a space that reflects the unique needs of your community and adapts as it grows."
               mediaPlacement="left"
               label="Admin and Tools"
               title="Manage your Community"
               items={adminFeatures}
            />
         </div>
         <div id="pricing" className="section">
            <PricingBlock />
         </div>

         <ContactModal />
      </>
   )
}

export default CommunitiesHome
